import { http } from 'viem';
import { createConfig } from 'wagmi';
import { mainnet, bsc, polygon, base, arbitrum, optimism, avalanche } from 'wagmi/chains';
import { injected } from 'wagmi/connectors';

// Define the BESC HyperChain
const bescHyperChain = {
  id: 2372,
  name: 'BESC HyperChain',
  network: 'besc',
  nativeCurrency: {
    name: 'BESC',
    symbol: 'BESC',
    decimals: 18,
  },
  rpcUrls: {
    default: { http: ['https://rpc.beschyperchain.com'] },
    public: { http: ['https://rpc.beschyperchain.com'] },
  },
  blockExplorers: {
    default: { name: 'BESC Explorer', url: 'https://explorer.beschyperchain.com' },
  },
};

export const config = createConfig({
  chains: [mainnet, bsc, polygon, base, arbitrum, optimism, avalanche, bescHyperChain],
  connectors: [injected()],
  transports: {
    [mainnet.id]: http(),
    [bsc.id]: http(),
    [polygon.id]: http(),
    [base.id]: http(),
    [arbitrum.id]: http(),
    [optimism.id]: http(),
    [avalanche.id]: http(),
    [bescHyperChain.id]: http(),
  },
});